import '@/utils/flexible';
import { Toast, ToastHandler } from 'antd-mobile';
import { Request } from '@qfe/request';
import scout from '@qfe/scout';
import Pages from './enums/Pages';
import { getLocale } from './locales';
import { clearStoredFieldSession } from './pages/h5-promotion/shared/session-storage';
import { parseOtpProblem, shouldReauthenticateFieldSession } from './utils/otp-problem';
import scoutConfig from './scout.config';

let loadingHandler: ToastHandler;

function isH5(): boolean {
  return window.location.pathname?.startsWith(Pages.H5Home);
}

function isH5Promotion(): boolean {
  return window.location.pathname?.startsWith(Pages.H5PromotionRoot);
}

function redirectToFieldLogin(): void {
  clearStoredFieldSession();
  if (window.location.pathname !== Pages.H5PromotionLogin) {
    window.location.replace(Pages.H5PromotionLogin);
  }
}

interface HttpRequestError {
  message?: string;
  data?: { message?: string };
  response?: unknown;
  request?: { options?: { noToast?: boolean } };
}

function handleHttpRequestError(error: unknown): unknown {
  const requestError = error as HttpRequestError;
  const problem = parseOtpProblem(error);
  if (isH5Promotion() && shouldReauthenticateFieldSession(error)) {
    redirectToFieldLogin();
  }
  if (isH5() && !requestError.request?.options?.noToast) {
    Toast.show({
      content: problem?.message || requestError.data?.message || requestError.message,
    });
  }
  return requestError.response;
}

Request.config({
  prefix: '/api',
  errorHandler: handleHttpRequestError,
  onLoading(isLoading) {
    if (!isH5()) {
      return;
    }

    if (isLoading) {
      loadingHandler = Toast.show({
        icon: 'loading',
      });
    } else {
      loadingHandler?.close?.();
    }
  },
  onError(error) {
    if (isH5()) {
      Toast.show({
        content: error?.description || error?.message,
      });
    }
  },
  authConfig: {
    enableAuth: false,
  },
  dynamicHeaders: () => {
    return {
      platform: 'web',
      lang: getLocale() || 'en-US',
    };
  },
  // crypto:
  //   BUILD_ENV === 'prod'
  //     ? {
  //         key: 'Q2a3SdO5mY6Kb6Va',
  //         iv: '5e8y6w45ju8w9jq8',
  //       }
  //     : {
  //         key: 'CGl5h8Ls9veNVuYg',
  //         iv: 'yfnUr8OgvGs6RJYl',
  //       },
});

if (SWITCHES.scout) {
  scout.init(scoutConfig);
}

export async function render(oldRender: () => void): Promise<void> {
  oldRender();
}

/**
 * 路由信息，只定义需要用到的，还有其他属性
 */
interface Route {
  /**
   * 路径
   */
  path: Pages | string;

  /**
   * 标题
   */
  title: string;
}

/**
 * 匹配到路由信息，只定义需要用到的，还有其他属性
 */
interface MatchedRoute {
  route: Route;
}

interface RouteChangeEvent {
  matchedRoutes: MatchedRoute[];
}

// 路由变更
export function onRouteChange(e: RouteChangeEvent): void {
  if (!e.matchedRoutes || !e.matchedRoutes.length) {
    return;
  }
  const { route } = e.matchedRoutes[0];

  if (route?.title) {
    document.title = route.title;
  }
}
